import { PublikaciaChange, PublikaciaChangeApi } from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new PublikaciaChangeApi(apiConfiguration(tezauryPrefixPath));

const map = (publikovany: boolean): PublikaciaChange => ({
  publikovany,
});

// eslint-disable-next-line import/prefer-default-export
export const changePublikacia = async (
  terminUuid: string,
  publikovany: boolean,
  options: { headers?: AxiosRequestHeaders } = {},
): Promise<ClientResponse<void>> => {
  const { status } = await client.changePublikacia(terminUuid, map(publikovany), options);
  return {
    responseCode: status,
  };
};
